// Seen
// Ideally, we want this, but I'm not sure the backend is consistent with this. Revisit later.
//    If requiresAck and done_at: Nil, will be an Unchecked checkbox. 
//    If requiresAck and done_at: not Nil, will be a Checked checkbox.
//    If not requiresAck, will be a dash '-'.



import { Box, Card, CardHeader } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { TextBubble } from "components/common";
import CustomToolbar from "components/common/CustomToolbar";
import GemDrawerMenu from "components/common/DrawerMenu";
import { useAlerts, useUser } from "contexts";
import { formatDistanceToNow } from "date-fns";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import { ack_alert } from "queries";
import { useQuery } from "contexts";

function AlertsPage() {
  const { data, loading, error, refetchData } = useQuery(ack_alert, { enable: false });
  const { context: user_context, register_user } = useUser();
  const { user } = user_context;
  useEffect(() => {
    register_user();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const { dispatch, alerts } = useAlerts({ refetchInterval: 40000 });

  function formatDistanceDay(date) {
    return formatDistanceToNow(date, { addSuffix: true, includeSeconds: true }).replace('about ', '').replace('less than a', '1').replace('less than', '');
  }

  const nameAdminSortComparator = (v1, v2, param1, param2) => {
    const priorityOrder = ['Critical', 'High', 'Medium', 'Low', 'Expired'];
    if (priorityOrder.indexOf(v1.priority) === -1 || priorityOrder.indexOf(v2.priority) === -1) {
      return 0;
    } else if (v1.priority != v2.priority) {
      return priorityOrder.indexOf(v1.priority) > priorityOrder.indexOf(v2.priority) ? -1 : 1;
    }
    if (new Date(v1.occurredAt) === new Date(v2.occurredAt)) {
      return 0;
    }
    if (new Date(v1.occurredAt) === null || new Date(v2.occurredAt) === null) {
      return 0;
    }
    return new Date(v1.occurredAt) > new Date(v2.occurredAt);
  };

  function handle_ack(alert_id) {
    console.log("Handle ack for alert ID:", alert_id);

    // const contains_alert = (element) => element.id === alert_id;
    // if (!alerts.alerts.some(contains_alert)) return;

    // // TODO: Get actual user ID
    // set_acking(true);
    refetchData({ id: alert_id, user_id: 1 }, true);
  }

  const rows = alerts.alerts;
  const columns = [
    {
      field: 'priority',
      headerName: 'Priority',
      width: 100,
      valueGetter: (value, row) => ({
        priority: row.priority,
        occurredAt: row.occuredAt,
      }),
      valueFormatter: (value) => {
        return value.priority;
      },
      sortComparator: nameAdminSortComparator,
    },
    { field: 'displayType', headerName: 'Type', width: 100 },
    { field: 'status', headerName: 'Status', width: 100 },
    { field: 'text', headerName: 'Description', width: 800 },
    {
      field: 'requiresAck',
      headerName: 'Seen',
      width: 150,
      type: 'boolean',
      renderCell: (params) => {
        console.log("requiresAck renderCell", params);
        if (params.value) {
          return (
            <Checkbox
              checked={false}
              disabled={false}
              onClick={(e) => {
                e.stopPropagation();
                handle_ack(params.row.id);
                dispatch({
                  type: "ACK_ALERT",
                  payload: params.row.id,
                });
              }}
            />
          );
        }
        return (
          <Checkbox
            checked={true}
            disabled={true}
          />
        );
      }
    },
    {
      field: 'vehicle', headerName: 'Vehicle', width: 100, valueGetter: (value, rowParams) => {
        console.log("Params Vehicle", rowParams);
        return rowParams.vehicle ? rowParams.vehicle.displayName : 'N/A';
      }
    },
    {
      field: 'occuredAt', headerName: 'Occurred', width: 130, valueGetter: (params) => {
        const date = Date.parse(params);
        return new Date(date).toLocaleTimeString('en-US', { hour12: true });
      }
    },
    {
      field: 'timeElapsed', headerName: 'Time Elapsed', width: 120, valueGetter: (params, row) => {
        return formatDistanceDay(Date.parse(row.occuredAt));
      },
      renderCell: (params) => {
        if (new Date() - Date.parse(params.row.occuredAt) < 30 * 1000) {
          return (
            <div>
              {params.value} <span style={{ marginRight: "5px" }}><TextBubble colour="#4CAF50" /></span>
            </div>
          );
        }
        return params.value;
      },
    },
  ];

  const sortModel = [
    {
      field: 'priority',
      sort: 'desc',
    },
  ];

  const getRowClassName = (params) => {
    if (params.row.status === 'Expired') {
      return 'expired-light';
    }
    switch (params.row.priority) {
      case 'Critical':
        return 'critical-light';
      case 'High':
        return 'critical-light';
      case 'Medium':
        return 'warning-light';
      case 'Low':
        return 'info-light';
      case 'Expired':
        return 'expired-light';
      default:
        return '';
    }
  };
  // console.log("Alerts", alerts);

  const navigate = useNavigate();

  return (
    <Box display="flex" width="100%">
      <GemDrawerMenu />
      <Box sx={{ flexGrow: 1, padding: '5px' }}>
        <Card>
          <Box sx={{ backgroundColor: '#07A0C3', width: '100%', padding: '0px' }}>
            <CardHeader title="Alerts" sx={{ height: '60px' }} />
          </Box>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            getRowClassName={getRowClassName}
            sortModel={sortModel}
            slots={{
              toolbar: CustomToolbar,
            }}
            onRowClick={(params) => {
              navigate("/alert/" + params.row.id);
            }}
          />
        </Card>
      </Box>
    </Box>
  );
}

export default AlertsPage;